export { default } from './Talent'